module.exports = __webpack_public_path__ + "static/media/babor-empty.f2c348f9.svg";